export default {
  useDocumentCount: (field, tab) => {
    return true;
  },
  getPerPage: (tab) => {
    return 15;
  },
  getHead: () => {
    return [
      { name: "No.", style: { minWidth: "100px", width: "100px" } },
      { name: "부서명", key: "meta.com_name", isNoSort: true },
      { name: "팀명", key: "" },
      { name: "사업장명", key: "field_name" },
      { name: "담당주무관", key: "manager_name" },
      { name: "부서장", key: "meta.부서장" },
      { name: "사업기간" },
      { name: "사업장 연락처" },
    ];
  },

  getCol: (index, row, func) => {
    try {
      switch (index) {
        // No.
        case 0:
          return func.no;
        // 부서명
        case 1:
          const com_name = JSON.parse(row.meta).com_name;
          return com_name || "-";
        // 팀명
        case 2:
          const team_company_list = JSON.parse(row.meta).team_company_list;
          return team_company_list ? team_company_list.map(team => team.com_name).join(', ') : '-';
        // 사업장명
        case 3:
          return row.field_name || "-";
        // 담당주무관
        case 4:
          return row.manager_name || "-";
        // 부서장
        case 5:
          const 부서장 = JSON.parse(row.meta).부서장;
          return 부서장 || "-";
        // 사업기간
        case 6:
          const work_begin_at = row.work_begin_at;
          const work_end_at = row.work_end_at;
          let date = "";
          if (work_begin_at) date += func.date(work_begin_at);

          if (!!work_begin_at || !!work_end_at) date += "~";
          else date += "-";

          if (work_end_at) date += func.date(work_end_at);
          return date;
        // 사업장 연락처
        case 7:
          return row.phone || "-";
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
};
